import { useEffect, useState } from "react";
import { DocsTOC } from "./DocsTOC";

interface DocsContentProps {
  children: React.ReactNode;
}

interface TOCItem {
  id: string;
  title: string;
  level: number;
}

export function DocsContent({ children }: DocsContentProps) {
  const [tocItems, setTocItems] = useState<TOCItem[]>([]);
  const [activeId, setActiveId] = useState<string>("");

  useEffect(() => {
    const headings = document.querySelectorAll("h2[id], h3[id]");
    const items: TOCItem[] = Array.from(headings).map((heading) => ({
      id: heading.id,
      title: heading.textContent || "",
      level: parseInt(heading.tagName.charAt(1)),
    }));
    setTocItems(items);
  }, [children]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveId(entry.target.id);
          }
        });
      },
      { rootMargin: "-80px 0% -80% 0%" }
    );

    const headings = document.querySelectorAll("h2[id], h3[id]");
    headings.forEach((heading) => observer.observe(heading));

    return () => observer.disconnect();
  }, [children]);

  return (
    <div className="flex gap-8 xl:gap-12">
      <article className="prose prose-invert max-w-3xl flex-1 min-w-0">{children}</article>
      {tocItems.length > 0 && (
        <div className="hidden xl:block w-48 shrink-0 self-start sticky top-24">
          <DocsTOC items={tocItems} activeId={activeId} />
        </div>
      )}
    </div>
  );
}
